module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "padding": ".2rem 0 1rem 0"
    }
  }, [_c('van-cell-group', [_c('van-cell', {
    attrs: {
      "title": "单位",
      "value": _vm.row.danwei
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "队伍名称",
      "value": _vm.row.mingcheng,
      "label": '全称是 ' + _vm.row.danwei + _vm.row.mingcheng + '啦啦队'
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "场地照片"
    }
  }, _vm._l((_vm.row.heying), function(item) {
    return _c('a', {
      staticStyle: {
        "margin-left": "10px"
      },
      attrs: {
        "href": item.url
      }
    }, [_c('img', {
      staticStyle: {
        "max-height": "50px"
      },
      attrs: {
        "src": item.url
      }
    })])
  }), 0), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "报名状态"
    }
  }, [(_vm.row.memberstatus == 1) ? _c('div', [_vm._v("秩序册填写")]) : (_vm.row.memberstatus == 2) ? _c('div', [_vm._v("项目填写")]) : (_vm.row.memberstatus == 3) ? _c('div', [_vm._v("人员统计")]) : (_vm.row.memberstatus == 4) ? _c('div', [_vm._v("住宿信息")]) : (_vm.row.memberstatus == 5) ? _c('div', [_vm._v("等待付款")]) : (_vm.row.memberstatus == 6) ? _c('div', [_vm._v("报名成功")]) : _vm._e()])], 1), _vm._v(" "), _c('van-divider', [_vm._v("领队/联系人信息")]), _vm._v(" "), _c('van-cell-group', [_c('van-cell', {
    attrs: {
      "title": "领队姓名",
      "value": _vm.row.ldname
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "证件类型"
    }
  }, [(_vm.row.ldcardtype == 1) ? _c('div', [_vm._v("身份证")]) : (_vm.row.ldcardtype == 2) ? _c('div', [_vm._v("护照")]) : (_vm.row.ldcardtype == 3) ? _c('div', [_vm._v("其他")]) : _vm._e()]), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "证件号码",
      "value": _vm.row.ldnum
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "领队性别",
      "value": _vm.row.ldsex == 1 ? '男' : '女'
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "领队手机",
      "value": _vm.row.phone
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "联系人",
      "value": _vm.row.lxname
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "联系人手机",
      "value": _vm.row.lxphone
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "readonly": "",
      "clickable": "",
      "input-align": "right",
      "label": "裁判"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.row.caipan.length > 0),
      expression: "row.caipan.length>0"
    }],
    staticClass: "memberResultWrap"
  }, _vm._l((_vm.row.caipan), function(caipan, index) {
    return _c('div', {
      staticClass: "memberLi"
    }, [_c('van-tag', {
      key: index,
      attrs: {
        "round": "",
        "color": "#fff",
        "text-color": "#666",
        "size": "large",
        "type": "primary"
      }
    }, [_vm._v(" " + _vm._s(caipan.name) + " " + _vm._s(caipan.num) + "\n        ")])], 1)
  }), 0), _vm._v(" "), _c('van-field', {
    attrs: {
      "readonly": "",
      "input-align": "right",
      "label": "教练"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.row.jiaolian.length > 0),
      expression: "row.jiaolian.length>0"
    }],
    staticClass: "memberResultWrap"
  }, _vm._l((_vm.row.jiaolian), function(jiaolian, index) {
    return _c('div', {
      staticClass: "memberLi"
    }, [_c('van-tag', {
      key: index,
      attrs: {
        "round": "",
        "color": "#fff",
        "text-color": "#666",
        "size": "large",
        "type": "primary"
      }
    }, [_vm._v(" " + _vm._s(jiaolian.name) + " " + _vm._s(jiaolian.num) + "\n        ")])], 1)
  }), 0)], 1), _vm._v(" "), _vm._l((_vm.row.subjectlist), function(subject, index) {
    return _c('div', [_c('van-divider', [_vm._v("项目信息" + _vm._s(index + 1))]), _vm._v(" "), _c('van-cell-group', [_c('van-cell', {
      attrs: {
        "readonly": "",
        "clickable": "",
        "title": "项目"
      }
    }), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (subject.subject_name),
        expression: "subject.subject_name"
      }],
      staticClass: "operate-desc-left"
    }, [_vm._v(_vm._s(subject.subject_name))]), _vm._v(" "), _c('van-field', {
      attrs: {
        "readonly": "",
        "clickable": "",
        "label": "参赛运动员"
      }
    }), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (subject.yundongyuan.length > 0),
        expression: "subject.yundongyuan.length>0"
      }],
      staticClass: "memberResultWrap"
    }, _vm._l((subject.yundongyuan), function(yundongyuan, index) {
      return _c('div', {
        staticClass: "memberLi"
      }, [_vm._v("\n          运动员" + _vm._s(index + 1) + "\n          "), _c('van-tag', {
        key: index,
        attrs: {
          "round": "",
          "color": "#fff",
          "text-color": "#666",
          "size": "large",
          "type": "primary"
        }
      }, [_vm._v(" " + _vm._s(yundongyuan.name) + " " + _vm._s(yundongyuan.num) + "\n          ")])], 1)
    }), 0), _vm._v(" "), _c('van-field', {
      attrs: {
        "readonly": "",
        "clickable": "",
        "input-align": "right",
        "label": "替补运动员"
      }
    }), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (subject.tbydy.length > 0),
        expression: "subject.tbydy.length>0"
      }],
      staticClass: "memberResultWrap"
    }, _vm._l((subject.tbydy), function(tbydy, index) {
      return _c('div', {
        staticClass: "memberLi"
      }, [_vm._v("\n          替补运动员" + _vm._s(index + 1) + "\n          "), _c('van-tag', {
        key: index,
        attrs: {
          "round": "",
          "color": "#fff",
          "text-color": "#666",
          "size": "large",
          "type": "primary"
        }
      }, [_vm._v(" " + _vm._s(tbydy.name) + " " + _vm._s(tbydy.num) + "\n          ")])], 1)
    }), 0), _vm._v(" "), _c('van-field', {
      attrs: {
        "readonly": "",
        "clickable": "",
        "input-align": "right",
        "label": "教练"
      }
    }), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (subject.jiaolian.length > 0),
        expression: "subject.jiaolian.length>0"
      }],
      staticClass: "memberResultWrap"
    }, _vm._l((subject.jiaolian), function(jiaolian, index) {
      return _c('div', {
        staticClass: "memberLi"
      }, [_vm._v("\n          教练员" + _vm._s(index + 1) + "\n          "), _c('van-tag', {
        key: index,
        attrs: {
          "round": "",
          "color": "#fff",
          "text-color": "#666",
          "size": "large",
          "type": "primary"
        }
      }, [_vm._v(" " + _vm._s(jiaolian.name) + " " + _vm._s(jiaolian.num) + "\n          ")])], 1)
    }), 0)], 1)], 1)
  }), _vm._v(" "), _c('van-divider', [_vm._v("食宿信息")]), _vm._v(" "), _vm._l((_vm.row.room_list), function(room, index) {
    return _c('van-cell-group', {
      key: index
    }, [(room.name) ? _c('van-field', {
      attrs: {
        "readonly": "",
        "clickable": "",
        "label": "房型",
        "input-align": "right",
        "value": room.name + ' ' + room.price + '元 限住' + room.limit + '人'
      }
    }) : _vm._e(), _vm._v(" "), _c('van-field', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (room.name),
        expression: "room.name"
      }],
      attrs: {
        "readonly": "",
        "clickable": "",
        "input-align": "right",
        "label": "入住人"
      }
    }), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (room.member.length > 0),
        expression: "room.member.length>0"
      }],
      staticClass: "memberResultWrap"
    }, _vm._l((room.member), function(user, index) {
      return _c('div', {
        staticClass: "memberLi"
      }, [_vm._v("\n        入住人" + _vm._s(index + 1) + "\n        "), _c('van-tag', {
        key: index,
        attrs: {
          "round": "",
          "color": "#fff",
          "text-color": "#666",
          "size": "large",
          "type": "primary"
        }
      }, [_vm._v(" " + _vm._s(user.name) + " " + _vm._s(_vm._f("sexName")(user.sex)) + " " + _vm._s(_vm._f("typeName")(user.type)) + "\n        ")])], 1)
    }), 0)], 1)
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-04b1976a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/weiyuanhui/apps/sai/SaiApplyDetail.vue
// module id = 2176
// module chunks = 0